import { render } from "./Factors.vue?vue&type=template&id=81aaf944&scoped=true"
import script from "./Factors.vue?vue&type=script&lang=js"
export * from "./Factors.vue?vue&type=script&lang=js"

import "./Factors.vue?vue&type=style&index=0&id=81aaf944&scoped=true&lang=scss"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81aaf944"]])

export default __exports__